/**
 * HierarchyAgGridHook
 *
 * Grid for /admin/merchants/hierarchy. Same underlying data as
 * GroupsAgGridHook: a flat, paginated AG Grid of groups. Clicking a group
 * pushes its id to the LiveView, which renders that group's Brand ->
 * Merchant tree as a plain panel below the grid.
 *
 * Not using AG Grid's treeData feature — see GroupsAgGridHook's header
 * comment: this app's vendored ag-grid-enterprise.js and
 * ag-grid-community.min.js don't share Column classes, and treeData's
 * auto-group column crashes outright (confirmed: "getDisplayedChildren is
 * not a function") because of it.
 */

import { mountServerSideGrid } from "../base/ServerSideAgGridHook";

const PAGE_SIZE = 25;

const HierarchyAgGridHook = {
  mounted() {
    if (!window.agGrid || !window.agGrid.createGrid) {
      console.error("HierarchyAgGridHook: agGrid not found on window");
      return;
    }

    const columnDefs = [
      { headerName: "Group", field: "name", flex: 1.2, minWidth: 160 },
      { headerName: "Code", field: "code", width: 140 },
      { headerName: "Status", field: "status", width: 120 },
      { headerName: "MCC", field: "mcc_code", width: 120 },
      { headerName: "Brands", field: "brand_count", width: 100, sortable: false },
    ];

    this.gridApi = mountServerSideGrid(this, {
      columnDefs,
      rowsEvent: "hierarchy:rows",
      refreshEvent: "hierarchy:refresh",
      pageSize: PAGE_SIZE,
      gridOptions: {
        onRowClicked: (params) => {
          if (params.data) this.pushEvent("hierarchy:select", { group_id: params.data.id });
        },
      },
    });
  },

  destroyed() {
    if (this.gridApi) {
      this.gridApi.destroy();
      this.gridApi = null;
    }
  },
};

export default HierarchyAgGridHook;
